import React from 'react';

const PartnerItem = ({ partner }) => {
  const content = (
    <div
      className="flex items-center justify-center h-28 md:h-36 px-8 md:px-12 group cursor-pointer flex-shrink-0"
      data-testid={`partner-logo-${partner.name?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {partner.logo_url ? (
        <img
          src={partner.logo_url}
          alt={partner.name}
          className="max-h-20 md:max-h-28 max-w-[180px] md:max-w-[260px] w-auto object-contain select-none grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 group-hover:scale-110"
          loading="lazy"
          draggable={false}
          onError={(e) => { e.target.style.display = 'none'; if (e.target.nextSibling) e.target.nextSibling.style.display = 'inline'; }}
        />
      ) : null}
      <span
        className="select-none whitespace-nowrap font-bold text-slate-400 group-hover:text-slate-800 transition-colors duration-500 text-xl"
        style={{ display: partner.logo_url ? 'none' : 'inline' }}
      >
        {partner.name}
      </span>
    </div>
  );

  if (partner.website) {
    return (
      <a href={partner.website} target="_blank" rel="noopener noreferrer" className="block flex-shrink-0">
        {content}
      </a>
    );
  }
  return <div className="flex-shrink-0">{content}</div>;
};

const PartnersCarousel = ({ partners }) => {
  if (!partners || partners.length === 0) return null;

  const tripled = [...partners, ...partners, ...partners];

  return (
    <div className="w-full overflow-hidden" data-testid="partners-carousel">
      <div className="partner-track flex items-center" style={{ width: 'max-content' }}>
        {tripled.map((partner, i) => (
          <PartnerItem key={`${partner.id}-${i}`} partner={partner} />
        ))}
      </div>
    </div>
  );
};

export default PartnersCarousel;
